<template>

    <div class="task_sgin_layout">
        <div class="flex-row">
            <div v-for="(item, index) in taskList" class="home_tab" :key="index">
                <div class="task_sgin_item_layout_today" v-if="item.checked == false && item.isToday">
                    <div class="cl_center">
                        <div class="bee_task_logo_true"></div>

                        <div class="task_sgin_reward">
                            {{ item.xp }}
                        </div>

                        <div class="task_sgin_day">
                            Day {{ item.day }}
                        </div>

                    </div>
                </div>

                <div v-else-if="item.checked" class="task_sgin_item_layout">
                    <div class="cl_center">
                        <div class="bee_task_logo_true"></div>

                        <div class="task_sgin_reward_true">
                            <img :src="signIcon" class="sign_layout">
                            {{ item.xp }}
                        </div>

                        <div class="task_sgin_day" style="opacity: 0.5;">
                            Day {{ item.day }}
                        </div>

                    </div>
                </div>

                <div v-else class="task_sgin_item_layout_noDay">

                    <div class="cl_center">
                        <div class="bee_uncheck_in_logo"></div>

                        <div class="task_sgin_reward" style="color:#A0A0A0; background:#EFEBEB;">{{ item.xp }}</div>

                        <div class="task_sgin_day" style="color: #999999;">
                            Day {{ item.day }}
                        </div>

                    </div>
                </div>


            </div>

        </div>



    </div>

</template>

<script>
import {
    baseUrl, test_twitter_auth_url, discord_auth_url, api_base_url
} from "../../util/mock.js"
import Toast from "../../components/message.js";
import successView from "./signDialog.vue"
import { addEmit, resultEmitEvent } from "../../util/event";
import icon_sign from '../../assets/icon_sign_true.png';

export default {
    name: 'signView',
    props: {
        taskList: [],
    },

    components: { successView },

    data() {
        return {
            signIcon: "",
            tabIndex: 0,
            tgJs: "",

        }
    },

    watch: {

    },

    methods: {
        async getCheckinTasks() {

             var e_mail = "";
            var userData = localStorage.getItem("bee_user_login_status", null);
            if (userData != null && userData != undefined) {
                const user = JSON.parse(userData);
                e_mail = user.user.email;
            }

            const options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                body: new URLSearchParams({
                    action: 'bee_checkinData',
                     userInfo: e_mail,
                }),
            };

            const userInfoData = await fetch(`${baseUrl()}/wp-admin/admin-ajax.php`, options)
            // console.log(userInfoData);
            let r_data = await userInfoData.json()
            let wp_data = r_data.data.data;
            let json = JSON.parse(wp_data);
            // console.log(json.data)
            this.taskList = json.data;
        },

        async doTask(item) {
                                    var e_mail = "";
            var userData = localStorage.getItem("bee_user_login_status", null);
            if (userData != null && userData != undefined) {
                const user = JSON.parse(userData);
                e_mail = user.user.email;
            }
            const options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                body: new URLSearchParams({
                    action: 'bee_checkin',
                   userInfo: e_mail,
                }),
            };

            const userInfoData = await fetch(`${baseUrl()}/wp-admin/admin-ajax.php`, options)
            // console.log(userInfoData);
            let r_data = await userInfoData.json()
            let wp_data = r_data.data.data;
            let json = JSON.parse(wp_data);
            if (json.data == true) {
                addEmit("dialog_show", item.xp);
                // this.getAppTasks();
            } else {
                Toast("Check in failed", "error");
            }

        },
        async verifyTask(item) {
            var url = api_base_url() + "/uni-task/app/verifyTask?userId=0&taskId=" + item.taskId;
            // console.log(url);
            const data = await fetch(url)
            this.postContent = await data.json()
            // console.log(this.postContent)
            // Toast("提交成功", "success");
            addEmit("dialog_show", item.xp);
        },



        async doSign(item) {
            if (item.checked == false) {
                await this.doTask(item);
            }
        }
    },

    mounted() {
        this.signIcon = icon_sign
        //  this.getCheckinTasks();
    },


}

</script>

<style scoped>
.flex-row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    max-width: 290px;
}

@media (max-width:767.98px) {}

.task_sgin_layout {
    border-radius: 8px;
    border: 1px #000;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}


.bee_task_logo {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    border-radius: 100%;
    background-image: url("../../assets/icon_task_reward_logo.png");
    background-size: cover;
    background-repeat: no-repeat;
}

.bee_uncheck_in_logo {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    border-radius: 100%;
    background-image: url("../../assets/icon_un_checkin.png");
    background-size: cover;
    background-repeat: no-repeat;
}

.bee_task_logo_true {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    border-radius: 100%;
    opacity: 0.5;
    background: url("../../assets/icon_task_reward_logo.png") lightgray 50% / cover no-repeat;
}

.bee_experience_logo {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    border-radius: 100%;
    margin-left: 2px;
}

.task_left_colunm_layout {
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: flex-start;
    flex: 1;
}

.task_left_row_layout {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.task_title {
    color: #792F11;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.task_sgin_reward {
    color: #792F11;
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin-top: 4px;
    border-radius: 12px;
    background: #FFE48B;
    padding-left: 6px;
    padding-right: 6px;
}

.task_sgin_reward_true {
    color: #792F11;
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin-top: 4px;
    border-radius: 12px;
    background: #FFE48B;
    padding-left: 6px;
    padding-right: 6px;
    opacity: 0.5;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.task_sgin_day {
    color: #792F11;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-top: 4px;
    width: 52px;
}

.task_sgin_send {
    margin-top: 20px;
    border-radius: 30px;
    background: #FFAE00;
    color: #FFF;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 36px;
    /* 166.667% */
    letter-spacing: 0.12px;
    padding-left: 12px;
    padding-right: 12px;
    width: 58px;
    margin-right: 6px;
    height: 36px;
}

.cl_center {
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
    margin-top: 16px;
    margin-bottom: 16px;
}

.sign_layout {
    width: 10px;
    height: 10px;
}

.task_sgin_item_layout_today {
    border-radius: 8px;
    border: 1px solid #FFE48B;
    background: #FFF8E1;
    text-align: center;
    -webkit-text-stroke-width: 1;
    -webkit-text-stroke-color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    /* 142.857% */
    letter-spacing: 0.14px;
    margin-top: 8px;
    flex-direction: column;
    display: flex;
    align-items: center;
    align-items: center;
    justify-items: center;
    margin-right: 2px;
    margin-left: 2px;
    cursor: pointer;

}

.task_sgin_item_layout {
    border-radius: 8px;
    border: 1px #000;
    background: #FFF8E1;
    text-align: center;
    -webkit-text-stroke-width: 1;
    -webkit-text-stroke-color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    /* 142.857% */
    letter-spacing: 0.14px;
    margin-top: 8px;
    flex-direction: column;
    display: flex;
    align-items: center;
    align-items: center;
    justify-items: center;
    margin-right: 3px;
    margin-left: 3px;
    cursor: pointer;
}

.task_sgin_item_layout_noDay {
    border-radius: 8px;
    border: 1px #000;
    background: #F8F6F6;
    text-align: center;
    -webkit-text-stroke-width: 1;
    -webkit-text-stroke-color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    /* 142.857% */
    letter-spacing: 0.14px;
    margin-top: 8px;
    flex-direction: column;
    display: flex;
    align-items: center;
    align-items: center;
    justify-items: center;
    margin-right: 3px;
    margin-left: 3px;
    cursor: pointer;
}
</style>